import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {
	constructor(private router: Router) {}

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (localStorage.token && localStorage.user) {
			return true;
		} else {
			this.router.navigate(['/login']);
			return false;
		}
	}
}
